var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    { staticClass: "white-card shadow-sm", attrs: { title: _setup.planTitle } },
    [
      _c("div", { class: { busy: _vm.loading } }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-spinner", {
                  staticClass: "my-2",
                  attrs: { variant: "primary" },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && _vm.subscription
          ? _c(
              "div",
              [
                _c("b-card-text", [
                  _c(
                    "h4",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.store,
                          expression: "store",
                        },
                      ],
                      staticClass: "store-text m-0",
                    },
                    [
                      _vm._v("\n                    Store: "),
                      _c("span", { staticClass: "primary-text" }, [
                        _vm._v(_vm._s(_vm.store)),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }